import React from 'react';
import { PrimaryButton, PrimaryButtonProps } from './PrimaryButton';
import InputIcon from '@material-ui/icons/Input';

export type ImportButtonProps = PrimaryButtonProps & {
}

export function ImportButton (props: ImportButtonProps) {
    return <PrimaryButton startIcon={<InputIcon />} {...props}>Importar</PrimaryButton>
}